import type { ReactNode } from 'react';

interface FlowStepProps {
  stepLabel: string;
  children: ReactNode;
}

export function FlowStep({ stepLabel, children }: FlowStepProps) {
  return (
    <div>
      <div style={{ fontSize: 13, fontWeight: 500, color: 'var(--text-muted)', marginBottom: 16, letterSpacing: '0.02em', textTransform: 'uppercase' }}>
        {stepLabel}
      </div>
      {children}
    </div>
  );
}
